import { render, staticRenderFns } from "./TradeCoins.vue?vue&type=template&id=74d287c1&scoped=true&"
import script from "./TradeCoins.vue?vue&type=script&lang=ts&"
export * from "./TradeCoins.vue?vue&type=script&lang=ts&"
import style0 from "./TradeCoins.vue?vue&type=style&index=0&id=74d287c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d287c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VChipGroup,VDialog,VImg})
